<template>
<div class="yixiaolie">
    <div class="header2">
        <p>人员结算比例</p>
    </div>

    <div class="tableBox">
        <table class="table table-bordered table-hover" v-loading="loading2" style="font-size: 14px;">
            <thead>
            <tr>
                <th>序号</th>
                <th>职位</th>
                <th>姓名</th>
                <th>分成比例</th>
                <th>是否测评师</th>
                <th>分成比例</th>

            </tr>
            </thead>

            <tbody>
            <tr v-if="status">
                <td>暂无数据</td>
            </tr>
            <tr  v-if="!status" v-for="(ta,index) in tabdata" :key="index">
                <td>{{index+1}}</td>
                <td>{{ta.gangwei}}</td>
                <td>{{ta.username}}</td>
                <td>
                    <el-input-number size="mini" v-model="ta.settlement_normal" style="width: 80px" controls-position="right" @change="gaibian(1,ta.user_id,ta.settlement_normal)" :min="0" :max="100"></el-input-number> %
                </td>
                <td>{{ta.cpteacher}}</td>
                <td>
                    <span v-if="ta.cp_teacher==2">
                          <el-input-number size="mini" v-model="ta.settlement_cp" style="width: 80px" controls-position="right"  @change="gaibian(2,ta.user_id,ta.settlement_cp)" :min="0" :max="100"></el-input-number> %
                    </span>

                </td>
            </tr>



            </tbody>

        </table>
    </div>





</div>
</template>

<script>
export default {

    data() {
        return{
            centre_id:'',
            loading2:false,
            tabdata:'',
            testnum:'1',
            date1:'',
            status:'',
            token:''
        }
  },
    methods:{
        gaibian:function (type,uid,shuju) {
            let self=this;
//                console.log(type)
//                console.log(uid)
//                console.log(shuju)
            if(type==1){
                $.ajax({
                    type: 'POST',
                    url: process.env.apiUrl + "saas/settlement/settlement_update",
                    data: {
                        user_id:uid,
                        type:type,
                        settlement_normal:shuju,
                        token:self.token
                    },
                    beforeSend: function(xhr) {
//                            self.loading2=true
                    },
                    success: function (data) {
//                            console.log(data)
                        if(data.status!=1){
                            self.$message.error(`设定结算比例失败!`);
                        }

                    },
                    error:function (data) {

                        self.$message.error(`设定结算比例失败!`);
                    }
                });



            }else if(type==2){

                $.ajax({
                    type: 'POST',
                    url: process.env.apiUrl + "saas/settlement/settlement_update",
                    data: {
                        user_id:uid,
                        type:type,
                        settlement_cp:shuju,
                        token:self.token
                    },
                    beforeSend: function(xhr) {
//                            self.loading2=true
                    },
                    success: function (data) {
//                            console.log(data)
                        if(data.status!=1){
                            self.$message.error(`设定结算比例失败!`);
                        }

                    },
                    error:function (data) {

                        self.$message.error(`设定结算比例失败!`);
                    }
                });



            }else{
                self.$message.error(`数据异常!`);
            }

        },
    },
    mounted:function(){


        var self=this;
       self.token=$.cookie('token')


        $.ajax({
            type: 'POST',
            url: process.env.apiUrl + "saas/settlement/settlement_index",
            data: {
                token:self.token
            },
            beforeSend: function(xhr) {
                self.loading2=true
            },
            success: function (data) {
                self.loading2=false;

                if(data.status==2){
                    self.status=true

                }else{
                    self.status=false
                    self.tabdata=data.data;

                }

            },
            error:function (data) {

                self.$message.error(`请求失败!`);
            }
        });






    }

}
</script>

<style scoped>
 body .yixiaolie{
      /*font-size: 18px;*/
  }
    .header{
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .header2{
        padding: 10px;
        box-sizing: border-box;
    }
.tablebtnBox{

    display: flex;
    justify-content: space-between;
}
    .tableBox{
        padding:0 10px;

    }
body,p{
  margin: 0;
  padding: 0;
  font-size: 11px;
}
.boxr{
  width: 224px;
  height:54px;
  /*line-height: 1.08;*/
  /*background: green;*/
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  display:-webkit-flex;
  align-items: center;
}
#app{
  width: 100%;
  height: 100vh;
  display: flex;
  display:-webkit-flex;
  flex-direction: column;
}
.mainBox{
  display: flex;
  display:-webkit-flex;
  flex: 1;


}
.fflex{
  display: flex;
  display:-webkit-flex;
}
.leftBox{
  width: 70px;
  height: 100%;
  background: #E6BE8A;
  border-radius:10px 0 0 10px ;
  box-sizing: border-box;
  padding-top:30px;
  padding-bottom: 30px;

}
.rightBox{
  flex: 1;
  flex-direction: column;
}
.mainbox{
  flex: 1;
}
.bottombox{
  height: 40px;
  justify-content: center;
  align-items: center;
  color: #666;
  width: 100%;
  background:#f1f1f1 ;
}
.mainhead{
  display: flex;
  display: -webkit-flex;
  height: 43px;
  background: #f1f1f1;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left:8px;
  padding-right: 8px;
}
nav{
  width: 100%;
  height: auto;
  overflow-y:scroll ;
  overflow-x:visible ;
}
.navlist{
  height: 55px;
  justify-content: center;
  align-items: center;

}
.tubiaoc{
  display: inline;
  text-align: center;
}
.navimg{
  width: 28px;
  height: 28px;
}
.navinfo{
  color: #fff;
  margin-top: -2.5px;
}
.logotitle{
  font-size: 14px;
  color:#6355a2 ;
  margin-left: 15px;
  font-weight: 700;
  margin-top: 13px;
  letter-spacing:0.5px;
}
.mainbox2{
  flex-direction: column;
  flex:1;
}
.headleft{
  height: 24px;
}
.headright{
  height: 24px;
  justify-content: flex-end;
  align-items: center;
}
.jumpindex{
  width:55px ;
  height: 24px;
}
.centername{
  line-height: 24px;
  margin-left: 10px;
}
.HeadPurBtn{
  padding:3px  9px;
  border-radius: 13px;
  background: #E6BE8A;
  color: #fff;
}
.HeadHelpBtn{
  width: 50px;
  margin-left: 15px;
}
.inner_body{
  background: #f1f1f1;
}



.zaixiankef .el-dialog__body{
  padding: 10px 10px;

}

.zaixiankef .el-dialog__body p{
  font-size: 11px;
}


.zaixiankef .el-dialog .el-dialog__header{
  background: #E6BE8A;
  text-align: center;
  padding: 8px;
  /*border-radius: 10px 10px 0 0;*/

}
.zaixiankef .el-dialog .el-dialog__header  .el-dialog__title{
  color: #fff;
  font-size: 18px;
}
.zaixiankef .el-dialog__headerbtn{
  top:8px;
  right: 8px;
  font-size: 15px;
}
.zaixiankef .el-dialog__headerbtn .el-dialog__close{
  color: #fff;
}

.tanchuang2 .el-dialog__body{
  padding: 15px;
  height: 270px;
  overflow-y: scroll;
}
.tanchuang2 .el-dialog__footer{
  border-top: 1px solid #e5e5e5;
}
.clearfloat:after{display:block;clear:both;content:"";visibility:hidden;height:0}
.clearfloat{zoom:1}

.yongtou {
  float: right;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  overflow: hidden;
}
.yongtou2 {
  float: left;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  overflow: hidden;
}

.yLbox {
  margin-right: 57px;
  padding: 17px 10px 17px 10px;
  line-height: 20px;
  font-size: 14px;
  background: #fdb06a;
  border-radius: 10px;
}
.yLbox2 {
  margin-left: 57px;
  padding: 17px 10px 17px 10px;
  line-height: 20px;
  font-size: 14px;
  background: #eee;
  border-radius: 10px;
}

.fasongBtn {
  width: 130px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 16px;
  border-radius: 16px;
  float: left;
  cursor: pointer;
  margin-top: 20px;
  background: #fdb06a;
  box-shadow: #f7dcc4 3px 5px 10px;
}

.genjilist{list-style: none;padding: 0;}


.genjilist li{
  height: 35px;
  box-sizing: border-box;
  line-height: 35px;
  text-align: center;
  color:#E6BE8A ;
  background: #f1f1f1;
  border-bottom: 1px solid #d2cef3;
}



</style>
<style>
  body .el-popover{
    min-width: 50px;
    padding: 0;
  }
  .btngroup .el-radio__input{
      display: none;
  }
  .btngroup  .el-radio__label{
      padding-left: 0;
  }
  .btngroup{
      display: inline-block;
      margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ceping/renjies.vue